import { constants } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";

const grey100 = constants.colors.ui.neutral[100];
const grey700 = constants.colors.ui.neutral[700];

export const tabsContainerCss = {
  width: "100%",
};

export const tabsCss = {
  width: "100%",
};

export const tabsListCss = {
  borderBottom: "1px solid" + grey100,
};

export const tabsPanelCss = {
  paddingTop: "0",
};

export const textCss: CSSObject = {
  maxWidth: "716px",
  color: grey700,
  fontSize: "1.125rem",
  lineHeight: "2rem",
  fontWeight: 400,
  wordWrap: "break-word",
};
